import callApi from './backendService';

const basePath = `/frontend/api`;

export const sendClickRecord = (formData) => callApi({
  method: 'POST',
  endpoint: `${basePath}/desktop`,
  body: formData
});
